import React from "react";

const pickMenu = (menus, menuId) =>
  (menus.find((menu) => menu.id === menuId) || { menu: [] }).menu;

const withMegaMenu = (component) => {
  const Component = component;

  const Wrapper = (props) => {
    const { data, menuId, ...rest } = props;

    if (menuId) {
      const newData = {
        ...data,
        mega_menu: pickMenu(data.mega_menus, menuId),
      };

      return <Component data={{ ...newData }} {...rest} />;
    } else {
      return <Component data={{ ...data }} {...rest} />;
    }
  };

  return Wrapper;
};

export default withMegaMenu;
